<div class="page-outer-wrapper">

  <div class="admin-page-header">
    <div class="hamburger">
      <img (click)="toggleSidebar()" style="cursor: pointer;" src="/assets/images/menu-512.png" height="28" width="28">
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>

  <div class="page-content-background">

    <div class="page-content">

      <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

        <mat-sidenav #adminsidenav class="admin-sidebar">

          <admin-sidebar></admin-sidebar>

        </mat-sidenav>

        <mat-sidenav-content>

          <!-- [START] page content -->

          <mat-card style="width: 100%; display: block;">

            <mat-card-header>
              <mat-card-title>Subdivisions</mat-card-title>
            </mat-card-header>

            <mat-card-content style="padding-left: 16px;">

              <p>To create a new Subdivision use the Create input below.</p>

              <div>
                <p-inputgroup>
                  <input (keyup)="createSubdivision($event)" type="text" pInputText placeholder="New Subdivsion" id="createsubdivision">
                  <p-button
                    style="height: 32px;"
                    (click)="createSubdivision()"
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-check"
                    styleClass="p-button-success"
                  >
                  </p-button>
                </p-inputgroup>
              </div>

              <p>You manage existing subdivisions by updating the name or soft deleting.</p>

              <p-table  class="admin-dark-table" selectionMode="single"  sortField="name"  [value]="subdivisions" (sortFunction)="tableSort($event)" [customSort]="true">

                <ng-template pTemplate="header">
                  <tr style="background-color: #2D323D;">
                    <th width="80" pSortableColumn="id">ID<p-sortIcon field="id"></p-sortIcon></th>
                    <th pSortableColumn="name">name<p-sortIcon field="Name"></p-sortIcon></th>
                    <th>Status</th>
                    <th># Orgs</th>
                    <th># Projects</th>
                    <th># Users</th>
                    <th pSortableColumn="created_at">Created<p-sortIcon field="created_at" ></p-sortIcon></th>
                    <th>Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-sub>

                  <tr [className]="'userListrowWrapper'" >

                    <!-- OID -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{sub.id}}</td>

                    <!-- name -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <!-- allow inline editing on the name -->

                      <p-inplace
                        #component
                        class="subclass-{{sub.id}}"
                        closable="closable"
                        (onDeactivate)="subEditDeactivate(sub.id, component)"
                        (onActivate)="subEditActivate(sub.id, component)"
                        (keyup)="subEditKey($event, sub.id, component)">
                        <ng-template pTemplate="display">
                          {{ sub.name }}
                        </ng-template>
                        <ng-template pTemplate="content">
                          <input type="text" value="{{sub.name}}" pInputText>
                        </ng-template>
                      </p-inplace>

                    </td>

                    <!-- status -->
                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <div *ngIf="sub.is_deleted; then thenDeleted"></div>

                      <ng-template #thenDeleted>
                        <p-tag *ngIf="sub.is_deleted" severity="danger" value="Deleted" class="userlisttag"></p-tag>
                      </ng-template>

                    </td>

                    <!-- usage metrics -->

                    <td>{{sub.organizations.length}}</td>
                    <td>{{sub.projects.length}}</td>
                    <td>{{sub.users.length}}</td>

                    <!-- inception -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{sub.created_at}}</td>

                    <!-- available actions -->

                    <td style="font-size: 10px;">

                      <div *ngIf="sub.is_deleted; then thenBlock else elseBlock"></div>

                      <ng-template #thenBlock>

                        <!-- if the user was deleted, the ONLY thing you can do is undelete them. -->

                        <a class="useractionicon" (click)="unDeleteSubdivision(sub.id)">
                          <img width="16" src="assets/images/undelete-64.png">
                        </a>

                      </ng-template>

                      <ng-template #elseBlock>

                        <!-- soft delete (but only if no usage) -->

                        <a *ngIf="canDelete(sub.id)" class="useractionicon" (click)="deleteSubdivision(sub.id)">
                          <img width="16" src="assets/images/delete-64.png">
                        </a>

                      </ng-template>

                    </td>

                  </tr>

                </ng-template>

              </p-table>

            </mat-card-content>

          </mat-card>

        </mat-sidenav-content>

      </mat-sidenav-container>

    </div>

    <div id="pano-footer" class="pano-footer"></div>

  </div>

</div>
